import React from 'react';
import clsx from 'clsx';

type LessonWrapperProps = {
  active?: boolean;
  completed?: boolean;
  children: React.ReactNode;
  onClick: () => void;
};

export const LessonWrapper: React.FC<LessonWrapperProps> = ({
  active,
  completed,
  children,
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      className={clsx(
        'cursor-pointer',
        'transition-def',
        'py-xs pr-md pl-xl',
        'flex flex-row items-start gap-x-sm',
        active ? 'bg-accordionActive' : 'bg-contrast hover:bg-accordionHover',
        active
          ? 'text-blackBorder'
          : completed
            ? 'text-middleGray'
            : 'text-blackBorder'
      )}
    >
      <div className="flex flex-col">{children}</div>
    </div>
  );
};
